module.exports = __webpack_public_path__ + "static/media/bbbb.fb41329b.mp4";